import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import './LocationComponent.scss';

const LocationComponent = (props) => {
    const days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

    const formattedDate = {
        endDay: days[new Date(props.endDate).getDay()],
        startDay: days[new Date(props.startDate).getDay()]
    };

	/**
	 * Sets the index of the location that was clicked so we can determine
	 * what part of the survey we are in.
	 */
    const handleClick = () => {
        props.actions.setLocationIndex(props.index);
        window.scrollTo(0, 0);
    };

    const locationComponentClasses = classNames('location-component', {
        'available': props.isAvailable,
        'complete': props.isComplete,
        'in-progress': props.isInProgress
    });

    return (
        <Link className={locationComponentClasses} onClick={handleClick} to={props.nextPage}>
            <li className='location-component__wrapper' key={props.index} ref={props.childRef}>
                <section className="location-component__name">
                    <div>{props.name}</div>

                    {props.startDate && props.endDate && (
                    <div className='location-component__date'>
                        {`${formattedDate.startDay} ${'\u2013'} ${formattedDate.endDay}`}
                    </div>
	                )}
                </section>

                <section className='location-component__footer'>
                    <span className='location-component__indicator' />
                </section>
            </li>
        </Link>
    );
};

export default LocationComponent;



// WEBPACK FOOTER //
// ./application/components/LocationComponent/LocationComponent.jsx